/**
 * Local storage's used name for the latest project id
 */
export const LATEST_PROJECT_ID = 'latestProjectId';
/**
 * Local storage's used name for the latest account id
 */
export const LATEST_ACCOUNT_ID = 'latestAccountId';
